import { type FC } from "react";
import { cn } from "@/agents-v2/utils/cn";

export type SessionExpiredBannerProps = {
  onDismiss: () => void;
  onSignOut: () => void;
};

export const SessionExpiredBanner: FC<SessionExpiredBannerProps> = ({ onDismiss, onSignOut }) => (
  <div
    role="alert"
    className={cn(
      "relative mx-3 mt-3 rounded-md border border-danger/30 bg-danger-soft px-3 py-2.5 pr-8 text-sm text-danger"
    )}
  >
    <button
      type="button"
      aria-label="Dismiss"
      onClick={onDismiss}
      className="absolute right-2 top-2 flex size-5 items-center justify-center rounded hover:bg-danger/10"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        className="size-4"
        aria-hidden="true"
      >
        <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" />
      </svg>
    </button>
    <div className="font-medium">Your mytender login has expired</div>
    <div className="mt-0.5 text-danger/80">
      <button type="button" className="font-semibold underline" onClick={onSignOut}>
        Sign out
      </button>{" "}
      and sign back in to continue.
    </div>
  </div>
);
